import { configureStore } from "@reduxjs/toolkit";
import loader from "./reducers/loader";
import trigger from "./reducers/trigger";
import authData from "./reducers/authData";

export default configureStore({
  reducer: {
    loader:loader,
    trigger:trigger,
    authData:authData
  },
});
